import axios from 'axios';

const state = {
  list: {},
  fullCount: 0,
  sort: {
    field: 'start_on',
    direction: 'ASC',
  },
  page: {
    pageSize: 10,
    page: 1,
  },
  filter: '',
  category: '',
  publish: '',
  unclaimed: false,
  dateRange: {
    start: new Date(),
    end: null,
  },
};

const getters = {
  getEventById: st => id => st.list.find(e => e._id === id),
};

const actions = {
  async getEvents({ commit, state: st }) {
    // debugger;
    let url = `${process.env.VUE_APP_API_EVENTS_ROOT}/events`;
    url += `?paging=true&page=${st.page.page}&pageSize=${st.page.pageSize}`;
    if (st.sort.field) {
      url += `&sorting=true&sortField=${st.sort.field}&sortDirection=${st.sort.direction}`;
    }
    if (st.filter && st.filter !== '') {
      url += `&filtering=true&filter=${st.filter}`;
    }
    if (st.category && st.category !== '') {
      url += `&category=${st.category}`;
    }
    if (st.publish && st.publish !== '') {
      url += `&publish=${st.publish}`;
    }
    if (st.unclaimed) {
      url += '&unclaimed=true';
    }
    if (st.dateRange.start) {
      url += `&startDate=${st.dateRange.start}`;
    }
    if (st.dateRange.end) {
      url += `&endDate=${st.dateRange.end}`;
    }
    const response = await axios.get(url);
    commit('setEvents', response.data.events);
    commit('setCount', response.data.count);
  },
  async sortEvents({ commit, state: st, dispatch }, field) {
    if (st.sort.field === field) {
      commit('setSortDirection', st.sort.direction === 'asc' ? 'desc' : 'asc');
    } else {
      commit('setSortDirection', 'asc');
      commit('setSortField', field);
    }

    await dispatch('getEvents');
  },
  async sortEventsAscending({ commit, dispatch }, field) {
    commit('setSortDirection', 'asc');
    commit('setSortField', field);

    await dispatch('getEvents');
  },
  async getEvent({ commit }, id) {
    const response = await axios.get(`${process.env.VUE_APP_API_EVENTS_ROOT}/events/${id}`);
    commit('addEvent', response.data);
  },
  async setPage({ commit, dispatch }, page) {
    commit('setPage', page);
    await dispatch('getEvents');
  },
  resetFilters({ commit }) {
    commit('setDateRange', { start: new Date(), end: null });
    commit('setCategory', '');
    commit('setPublish', '');
    commit('setUnclaimed', false);
    commit('setFilter', '');
  },
};

const mutations = {
  setEvents(st, events) {
    st.list = events;
  },
  setCount(st, count) {
    st.fullCount = count;
  },
  addEvent(st, event) {
    if (!st.list.length) {
      st.list = [];
    }
    if (st.list.some(e => e._id === event._id)) {
      const index = st.list.findIndex(e => e._id === event._id);
      st.list[index] = event;
    } else {
      st.list.push(event);
    }
  },
  setSortField(st, field) {
    st.sort.field = field;
  },
  setSortDirection(st, direction) {
    st.sort.direction = direction;
  },
  setDateRange(st, dateRange) {
    st.dateRange = dateRange;
  },
  setCategory(st, category) {
    st.category = category;
  },
  setPublish(st, publish) {
    st.publish = publish;
  },
  setUnclaimed(st, unclaimed) {
    st.unclaimed = unclaimed;
  },
  setFilter(st, filter) {
    st.filter = filter;
  },
  setPage(st, page) {
    st.page.page = page;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
